import { useQuery } from "react-query";
import { fetchAPIPaymentType } from "../requests/PaymentTypes";

export function useQueryPaymentType(id: number, caller: string) {
    //console.log(caller + ' asking payment type for id: ', id)
    const onError = () => {};
    const query = useQuery("apiPaymentType", async () => await fetchAPIPaymentType(id), { onError });
    return query;
}